// const [editableNotes, setEditableNotes] = useState();
import { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import searchIcon from "../../assets/search_icon.png";
import paymentIcon from "../../assets/payment_icon.png";
import returnMoneyIcon from "../../assets/return-money.png";
import CustomButton from "../../components/CustomButton";
import Loader from "../../components/Loader";
import { toMoney } from "../../utils/toMoney";
import { formatDate } from "../../utils/toDate";
import TextDiv from "../../components/TextDiv";
import Modal from "../../components/Modal";
import BalanceBoxes from "../../components/BalanceBoxes";
import RoundedTable, {
  TABLE_CELL_TYPES,
} from "../../components/table-component/RoundedTable";
import { UserAuth } from "../../utils/AuthContext";
import CustomInput from "../../components/CustomInput";
import SearchFilter from "../../components/SearchFilter";
import InformationBox from "../../components/InformationBox";
import { getStudentPayment } from "../../services/StudentServices";
import StudentPaymentModal from "./StudentPaymentModal";
import HotdropdownV2 from "../../components/HotdropdownV2";
import { getAllEducationLevels } from "../../services/educationLevelServices";
import {
  updateStudentPayment,
  deleteStudentPayment,
} from "../../services/StudentServices";

import editIcon from "../../assets/edit_icon.png";
import deleteIcon from "../../assets/delete_Icon.png";
import closeIcon from "../../assets/close_icon.png";
import saveIcon from "../../assets/save_icon.png";
import printIcon from "../../assets/printer_purple.png";

import { pdf } from "@react-pdf/renderer";
import useLanguage from "../../utils/useLanguage";
import StudentTransactionStatementPDF from "../../components/StudentTransactionPdfTemplate"; // Adjust path as needed
import downloadIcon from "../../assets/download-icon.svg";
import axios from "axios";
import ReturnMoneyModal from "./ReturnMoneyModal";

const StudentTransactionModal = ({
  selected,
  handleToggleTransactionsModal,
  setShouldGetStudents,
  yearId,
}) => {
  const { t } = useTranslation("general");
  const { userData } = useContext(UserAuth);
  const { currentDirection } = useLanguage();

  // STATES - Pagination
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
  });

  // STATES - Modals
  const [paymentModal, setPaymentModal] = useState(false);
  const [returnMoneyModal, setReturnMoneyModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [editFormData, setEditFormData] = useState({
    amount: "",
    date: "",
    notes: "",
    StudentCategoryId: "",
  });

  // STATES - Search
  const [selectedTitle, setSelectedTitle] = useState({
    title: t("Date"),
    value: "date",
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [minAmount, setMinAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");
  const [educationLevels, setEducationLevels] = useState([]);
  const [searchTerm, setSearchTerm] = useState({
    title: t("selectAll"),
    value: "",
  });

  // STATES - Data
  const [studentPayments, setStudentPayments] = useState([]);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);

  // CONSTANTS
  const searchTitles = [
    { title: t("Date"), value: "date" },
    { title: t("amount"), value: "amount" },
    { title: t("receiptNumber"), value: "receiptNumber" },
    ...(yearId == null
      ? [{ title: t("academicLevel"), value: "academicLevel" }]
      : []),
  ];

  const tableTitles = [
    { value: "payment" },
    { value: "receiptNumber", keepOnMobile: true },
    { value: "Date", keepOnMobile: true },
    { value: "amount", keepOnMobile: true },
  ];

  // HANDLERS

  // Add this function inside your StudentTransactionModal component
  const handleDownloadPDF = async () => {
    setPdfLoading(true);

    try {
      const filterParams = buildFilterParams();
      filterParams.page = 1;
      filterParams.limit = 10000; // Get all records for PDF

      const response = await getStudentPayment(
        selected.studentYearId || selected.id,
        yearId,
        filterParams
      );

      if (response.status === 200 && response.data?.payments) {
        const blob = await pdf(
          <StudentTransactionStatementPDF
            language={currentDirection === "rtl" ? "AR" : "EN"}
            companyName={
              userData?.subCompany?.name ||
              localStorage.getItem("organizationName") ||
              ""
            }
            data={{
              student: selected,
              payments: response.data.payments,
              balance: response.data.balance,
            }}
            transactions={response.data.payments.map((payment) => ({
              ...payment,
              transactionName: payment.studentCategory
                ? payment.studentCategory.name
                : payment.type
                ? t("regisration")
                : payment.type !== "yearDept" && payment.amount < 0
                ? t("returnMoney")
                : t("installmentPayment"),
            }))}
            schoolName={
              userData?.organizationName ||
              localStorage.getItem("organizationName") ||
              ""
            }
          />
        ).toBlob();

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${selected?.fullName || "student-payments"}-${
          new Date().getMonth() + 1
        }-${new Date().getDay() + 1}-${(Math.random() * 1000).toFixed(0)}.pdf`;
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 5000);
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("PDF generation failed:", error);
    } finally {
      setPdfLoading(false);
    }
  };

  const handleSearchType = (type) => {
    setSelectedTitle(type);
    setSearchQuery("");
    setStartDate("");
    setEndDate("");
    setMinAmount("");
    setMaxAmount("");
    setSearchTerm({ title: t("selectAll"), value: "" });
  };

  const buildFilterParams = (searchQuery = "") => {
    const params = {
      page: pagination.currentPage,
      limit: 4,
    };

    if (selectedTitle?.value === "date" && (startDate || endDate)) {
      params.startDate = startDate;
      params.endDate = endDate;
    } else if (selectedTitle?.value === "amount") {
      if (minAmount) params.minAmount = parseFloat(minAmount);
      if (maxAmount) params.maxAmount = parseFloat(maxAmount);
    } else if (selectedTitle?.value === "academicLevel" && searchTerm?.value) {
      params.schoolClassId = searchTerm.value;
    } else if (searchQuery !== "") {
      params.search = searchQuery;
    }

    return params;
  };

  const getAllStudentPayments = async (
    page = 1,
    limit = 4,
    searchQuery = ""
  ) => {
    setLoading(true);

    try {
      const filterParams = buildFilterParams(searchQuery);
      filterParams.page = page;
      filterParams.limit = limit;

      const response = await getStudentPayment(
        selected.studentYearId || selected.id,
        yearId,
        filterParams
      );

      if (response.status === 200) {
        const data = response.data;

        const tableRows = (data.payments || []).map((payment) => [
          {
            value: (
              <div className="cell">
                <CustomButton
                  variant="transparent"
                  onClick={() => {
                    setSelectedTransaction({
                      ...payment,
                      transactionName: payment.studentCategory
                        ? payment.studentCategory.name
                        : payment.type
                        ? "regisration"
                        : payment.type !== "yearDept" && payment.amount < 0
                        ? "returnMoney"
                        : "installmentPayment",
                      amount: payment.amount,
                    });
                    setDetailsModal(true);
                  }}
                  content={
                    <div className="o-column o-column--gap-size_100 u-padding--top_100">
                      <div>
                        {payment.studentCategory
                          ? payment.studentCategory.name
                          : payment.type
                          ? t("regisration")
                          : payment.type !== "yearDept" && payment.amount < 0
                          ? t("returnMoney")
                          : t("installmentPayment")}
                      </div>
                      <span className="t-text-mini t-bold_normal">
                        {payment.class?.name}
                      </span>
                    </div>
                  }
                />
              </div>
            ),
            type: TABLE_CELL_TYPES.ELEMENT,
            keepOnMobile: true,
          },
          {
            value: payment.receiptNumber,
            type: TABLE_CELL_TYPES.TEXT,
            keepOnMobile: true,
          },
          {
            value: payment.date,
            type: TABLE_CELL_TYPES.DATE,
            keepOnMobile: true,
          },
          {
            value: payment.amount,
            type: TABLE_CELL_TYPES.MONEY,
            sign: payment.amount > 0 ? "positive-value" : "negative-value",
            bold: true,
            keepOnMobile: true,
            currency: t("IQD"),
          },
        ]);

        setPagination({
          currentPage: data.currentPage || page,
          totalPages: data.totalPages || 1,
          totalRecords: data.totalRecords || 0,
        });

        setStudentPayments(tableRows);
        setBalance(data.balance || 0);
      }
    } catch (error) {
      console.error("Failed to fetch student payments:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchEducationLevels = async (
    page = 1,
    limit = 5,
    isDropDown = false,
    searchTerm
  ) => {
    try {
      const response = await getAllEducationLevels({
        page,
        limit,
        search: searchTerm,
      });

      const transformedData = (response.data.classes || []).map((level) => ({
        title: level.name,
        value: level.id,
        price: level.price,
      }));

      if (page === 1) {
        setEducationLevels(transformedData);
      } else {
        setEducationLevels((prev) => [...prev, ...transformedData]);
      }

      return {
        status: response.status || 200,
        data: {
          classes: transformedData,
          totalPages: response.data.totalPages,
          totalRecords: response.data.totalRecords,
        },
      };
    } catch (error) {
      console.error("Error fetching education levels:", error);
      return {
        status: 500,
        data: { classes: [], totalPages: 1, totalRecords: 0 },
      };
    }
  };

  const handleSearch = () => {
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
    getAllStudentPayments(1, 4, searchQuery);
  };

  const handlePaginationChange = (newPage) => {
    setPagination((prev) => ({ ...prev, currentPage: newPage }));
    getAllStudentPayments(newPage, 4, searchQuery);
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    setStartDate("");
    setEndDate("");
    setMinAmount("");
    setMaxAmount("");
    setSearchTerm({ title: t("selectAll"), value: "" });
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
    getAllStudentPayments(1, 4, "");
  };

  const handleEditClick = () => {
    setEditFormData({
      amount: parseFloat(selectedTransaction?.amount) || "",
      date: selectedTransaction?.date
        ? selectedTransaction.date.split("T")[0]
        : "",
      notes: selectedTransaction?.notes || "",
      StudentCategoryId: selectedTransaction?.studentCategoryId || "",
    });
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditFormData({
      amount: "",
      date: "",
      notes: "",
      StudentCategoryId: "",
    });
  };

  const handleSaveEdit = async () => {
    try {
      setLoading(true);
      const response = await updateStudentPayment(selectedTransaction.id, {
        ...editFormData,
        amount:
          editFormData.amount < 0
            ? parseFloat(editFormData.amount) * -1
            : parseFloat(editFormData.amount),
        type:
          selectedTransaction.type !== "yearDept" &&
          selectedTransaction.amount < 0
            ? "reverseTransaction"
            : "",
      });

      if (response.status === 200) {
        setDetailsModal(false);
        setIsEditing(false);
        getAllStudentPayments(pagination.currentPage, 4, searchQuery);
        // Show success message if you have a toast system
      }
    } catch (error) {
      console.error("Error updating payment:", error);
      // Show error message if you have a toast system
    } finally {
      setLoading(false);
    }
  };

  const handleDeletePayment = async () => {
    try {
      setLoading(true);
      const response = await deleteStudentPayment(selectedTransaction.id);

      if (response.status === 200) {
        setDetailsModal(false);
        setShowDeleteConfirmation(false);
        getAllStudentPayments(pagination.currentPage, 4, searchQuery);
        // Show success message if you have a toast system
      }
    } catch (error) {
      console.error("Error deleting payment:", error);
      // Show error message if you have a toast system
    } finally {
      setLoading(false);
    }
  };

  const renderSearchInput = () => {
    switch (selectedTitle.value) {
      case "date":
        return (
          <div className="o-column-row-switcher o-column--gap-size_300">
            <CustomInput
              name="startDate"
              title={t("from")}
              type="date"
              thick
              onChange={(e) => setStartDate(e.target.value)}
              resetSearch={() => setStartDate("")}
              value={startDate}
            />
            <CustomInput
              name="endDate"
              title={t("to")}
              type="date"
              thick
              onChange={(e) => setEndDate(e.target.value)}
              resetSearch={() => setEndDate("")}
              value={endDate}
            />
          </div>
        );

      case "amount":
        return (
          <div className="o-column-row-switcher o-column--gap-size_300">
            <CustomInput
              name="minAmount"
              title={t("minAmount")}
              type="number"
              placeholder={t("minAmount")}
              thick
              onChange={(e) => setMinAmount(e.target.value)}
              resetSearch={() => setMinAmount("")}
              value={minAmount}
              flex
            />
            <CustomInput
              name="maxAmount"
              title={t("maxAmount")}
              type="number"
              placeholder={t("maxAmount")}
              thick
              onChange={(e) => setMaxAmount(e.target.value)}
              resetSearch={() => setMaxAmount("")}
              value={maxAmount}
              flex
            />
          </div>
        );

      case "academicLevel":
        return (
          <HotdropdownV2
            initOptions={[
              ...educationLevels,
              { title: t("selectAll"), value: "" },
            ]}
            selected={searchTerm?.title || ""}
            setSelected={(selected) => setSearchTerm(selected)}
            page="students"
            getData={(page, limit, isDropDown, query) =>
              fetchEducationLevels(page, limit, isDropDown, query)
            }
            optionsName="classes"
            thick
            key="academic-level-dropdown"
          />
        );

      default:
        return (
          <CustomInput
            placeholder={`${t("searchTitle")} ${t(selectedTitle?.value)}`}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            resetSearch={handleClearSearch}
            thick
            flex
          />
        );
    }
  };

  useEffect(() => {
    getAllStudentPayments(pagination.currentPage, 4, searchQuery);
  }, [pagination.currentPage]);

  return (
    <>
      <Modal
        title={t("transactions")}
        onClose={handleToggleTransactionsModal}
        footer={
          <>
            <>
              {studentPayments?.length > 0 && (
                <section>
                  {pdfLoading && <Loader />}
                  <div className="o-row o-row--horizontal-align_end u-margin--top_500 u-margin--bottom_400">
                    <CustomButton
                      variant="blank"
                      onClick={handleDownloadPDF}
                      disabled={pdfLoading}
                      icon={downloadIcon}
                      title={
                        pdfLoading ? t("generatingPdf") : t("downloadStatement")
                      }
                    />
                  </div>
                </section>
              )}
            </>
          </>
        }
        beforeFooterChildren={
          <BalanceBoxes
            boxes={[
              {
                title: "balance",
                value: balance,
                currency: t("IQD"),
              },
            ]}
          />
        }
      >
        {/* Student Name & Payment Button */}
        <section className="o-column-row-switcher o-row--horizontal-align_space-between u-padding--top_200">
          <TextDiv
            title="student"
            value={selected?.fullName}
            divClasses="o-row o-row--gap-size_300 o-row--vertical-align_center"
          />
          {userData?.userType === "orgUser" && (
            <div className="o-row o-row--gap-size_300">
              <CustomButton
                variant="green"
                title={t("payment")}
                onClick={() => setPaymentModal(true)}
                icon={paymentIcon}
                iconSize={22}
              />
              <CustomButton
                variant="red"
                title={t("returnMoney")}
                onClick={() => setReturnMoneyModal(true)}
                icon={returnMoneyIcon}
                iconSize={25}
              />
            </div>
          )}
        </section>

        {/* Search Section */}

        <div className="o-column o-column--gap-size_300">
          <label className="t-bold_semi-bold">
            {`${t("searchTitle")} ${t(selectedTitle?.title)}`}
          </label>
          <section className="o-column-row-switcher o-row--gap-size_300 o-column--vertical-align_end">
            <div className="o-row o-row--vertical-align_center o-column--vertical-align_end o-row--gap-size_300 u-width_full-width o-column--horizontal-align_space-between">
              {renderSearchInput()}
              <SearchFilter
                options={searchTitles}
                selected={selectedTitle}
                setSelected={handleSearchType}
                thick
              />
            </div>

            <CustomButton
              title={t("search")}
              onClick={handleSearch}
              icon={searchIcon}
              iconSize={15}
              classList="c-search-button"
            />
          </section>
        </div>

        {loading ? (
          <Loader />
        ) : (
          <>
            {studentPayments?.length > 0 ? (
              <section>
                <RoundedTable
                  titles={tableTitles}
                  rows={studentPayments}
                  pagination={pagination}
                  setPagination={setPagination}
                  onPaginationChange={handlePaginationChange}
                />
              </section>
            ) : (
              <InformationBox>{t("noTransactions")}</InformationBox>
            )}
          </>
        )}

        {paymentModal && (
          <StudentPaymentModal
            selectedStudent={selected}
            handleTogglePaymentModal={() => setPaymentModal(false)}
            refetchData={() => getAllStudentPayments()}
            setShouldGetStudents={setShouldGetStudents}
          />
        )}
        {returnMoneyModal && (
          <ReturnMoneyModal
            selectedStudent={selected}
            handleToggleReturnMoneyModal={() => setReturnMoneyModal(false)}
            refetchData={() => getAllStudentPayments()}
            setShouldGetStudents={setShouldGetStudents}
          />
        )}

        {detailsModal && (
          <Modal
            modalSize="c-modal--small"
            title="details"
            onClose={() => {
              setDetailsModal(false);
              setIsEditing(false);
            }}
            footer={
              <div className="o-row o-row--horizontal-align_end o-row--gap-size_400">
                {isEditing ? (
                  <>
                    <CustomButton
                      variant="blank"
                      title={t("cancel")}
                      onClick={handleCancelEdit}
                      icon={closeIcon}
                      iconSize={14}
                    />
                    <CustomButton
                      title={t("save")}
                      onClick={handleSaveEdit}
                      disabled={loading}
                      icon={saveIcon}
                      iconSize={14}
                    />
                  </>
                ) : (
                  selectedTransaction.type !== "yearDept" && (
                    <>
                      {/* <CustomButton
                        variant="blank"
                        title={t("print")}
                        icon={printIcon}
                        iconSize={16}
                      /> */}
                      <CustomButton
                        variant="blank"
                        title={t("edit")}
                        onClick={handleEditClick}
                        icon={editIcon}
                        iconSize={18}
                      />
                      <CustomButton
                        variant="red"
                        title={t("delete")}
                        onClick={() => setShowDeleteConfirmation(true)}
                        icon={deleteIcon}
                        iconSize={16}
                      />
                    </>
                  )
                )}
              </div>
            }
          >
            <div className="o-column o-column--gap-size_300">
              <TextDiv
                title="transaction"
                value={t(selectedTransaction?.transactionName)}
                divClasses="o-row o-row--vertical-align_center o-row--gap-size_500"
                pClasses="t-bold_semi-bold u-width-specific_150 u-margin_0"
              />
              <TextDiv
                title="educationLevel"
                value={selectedTransaction?.class?.name}
                divClasses="o-row o-row--vertical-align_center o-row--gap-size_500"
                pClasses="t-bold_semi-bold u-width-specific_150 u-margin_0"
              />

              <TextDiv
                title="receiptPaymentCode"
                value={selectedTransaction?.receiptNumber}
                divClasses="o-row o-row--vertical-align_center o-row--gap-size_500"
                pClasses="t-bold_semi-bold u-width-specific_150 u-margin_0"
              />

              {isEditing ? (
                <>
                  <div className="o-row o-row--vertical-align_center o-row--gap-size_500">
                    <p className="t-bold_semi-bold u-width-specific_150 u-margin_0">
                      {t("amount")}:
                    </p>
                    <CustomInput
                      type="moneyV2"
                      value={editFormData.amount}
                      onChange={(e) =>
                        setEditFormData((prev) => ({
                          ...prev,
                          amount: e.target.value,
                        }))
                      }
                      thick
                      flex
                    />
                  </div>

                  <div className="o-row o-row--vertical-align_center o-row--gap-size_500">
                    <p className="t-bold_semi-bold u-width-specific_150 u-margin_0">
                      {t("Date")}:
                    </p>
                    <CustomInput
                      type="date"
                      value={editFormData.date}
                      onChange={(e) =>
                        setEditFormData((prev) => ({
                          ...prev,
                          date: e.target.value,
                        }))
                      }
                      thick
                      flex
                    />
                  </div>

                  <div className="o-row o-row--vertical-align_start o-row--gap-size_500">
                    <p className="t-bold_semi-bold u-width-specific_150 u-margin_0">
                      {t("notes")}:
                    </p>
                    <CustomInput
                      type="textarea"
                      value={editFormData.notes}
                      onChange={(e) =>
                        setEditFormData((prev) => ({
                          ...prev,
                          notes: e.target.value,
                        }))
                      }
                      placeholder={t("notes")}
                      thick
                      flex
                    />
                  </div>
                </>
              ) : (
                <>
                  <TextDiv
                    title="amount"
                    value={`${toMoney(selectedTransaction?.amount)} ${t(
                      "IQD"
                    )}`}
                    divClasses="o-row o-row--vertical-align_center o-row--gap-size_500"
                    pClasses="t-bold_semi-bold u-width-specific_150 u-margin_0"
                  />
                  <TextDiv
                    title="Date"
                    value={formatDate(selectedTransaction?.date)}
                    divClasses="o-row o-row--vertical-align_center o-row--gap-size_500"
                    pClasses="t-bold_semi-bold u-width-specific_150 u-margin_0"
                  />
                  <TextDiv
                    title="notes"
                    value={selectedTransaction?.notes || t("noNotes")}
                    divClasses="o-row o-row--vertical-align_center o-row--gap-size_500"
                    pClasses="t-bold_semi-bold u-width-specific_150 u-margin_0"
                    spanClasses="break-word"
                  />
                </>
              )}
            </div>
          </Modal>
        )}

        {showDeleteConfirmation && (
          <Modal
            modalSize="c-modal--small"
            title={t("deleteConfirmation")}
            onClose={() => setShowDeleteConfirmation(false)}
            footer={
              <div className="o-row o-row--horizontal-align_end o-row--gap-size_400">
                <CustomButton
                  variant="blank"
                  title={t("cancel")}
                  onClick={() => setShowDeleteConfirmation(false)}
                  icon={closeIcon}
                  iconSize={14}
                />
                <CustomButton
                  variant="red"
                  title={t("delete")}
                  icon={deleteIcon}
                  iconSize={16}
                  onClick={handleDeletePayment}
                  disabled={loading}
                />
              </div>
            }
          >
            <p>{t("deletePaymentConfirmation")}</p>
          </Modal>
        )}
      </Modal>
    </>
  );
};

export default StudentTransactionModal;
